// extracted by mini-css-extract-plugin
export default {"font-renta":"WorkOrdersProcessedApproval_font-renta__zsNMS"};